import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";

import { SliderItemProps, SliderItem } from "./slider-item";
import { get } from "../../common/request";
import { APIS, Banner } from "../../pages/admin/common";

export function Slider() {
  const [items, setItems] = useState<SliderItemProps[]>([]);

  useEffect(() => {
    get(APIS.BANNER_LIST).then((res) => {
      setItems(
        res.data.map((item: Banner, index) => ({
          mediaUrl: item.mediaUrl,
          mediaType: item.mediaType === 0 ? "image" : "video",
          title: item.title,
          buttonText: item.buttonText,
          buttonLink: item.linkUrl,
          links: JSON.parse(item.extraLinks).map((link) => ({
            text: link.name,
            link: link.url
          })),
          index
        }))
      );
    });
  }, []);

  const itemsComp = items.map((item, index) => {
    return (
      <Carousel.Item key={index}>
        <SliderItem {...item} />
      </Carousel.Item>
    );
  });

  return <Carousel>{itemsComp}</Carousel>;
}
